import { Component } from '@angular/core';

@Component({
    selector: 'gbc-simple-spinner',
    templateUrl: './simple-spinner.component.html',
    styleUrls: ['./simple-spinner.component.scss'],
    standalone: true
})
export class SimpleSpinnerComponent {
}
